import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Dashboard.css";

const Dashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/admin/login");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate("/admin/login");
  };

  return (
    <div className="dashboard-wrapper">
      {/* Header */}
      <header className="dashboard-header">
        <h1>Admin Dashboard</h1>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </header>

      {/* Main actions */}
      <section className="dashboard-actions">
        <Link to="/admin/create-blog" className="dashboard-card">
          <h3>Create Blog</h3>
          <p>Write and publish a new blog post</p>
        </Link>

        <Link to="/blog" className="dashboard-card">
          <h3>View Blogs</h3>
          <p>See all published blog posts</p>
        </Link>
      </section>

      {/* Future content */}
      <section className="dashboard-content">
        <h2>Quick Overview</h2>
        <ul>
          <li>✔ Manage blog posts</li>
          <li>✔ Create drafts & publish</li>
          <li>✔ Secure admin access</li>
          <li>🚀 More features coming</li>
        </ul>
      </section>
    </div>
  );
};

export default Dashboard;
